var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7348 17.4889C15.1636 19.0893 14.2139 20.7343 12.6135 21.1631C11.0131 21.592 9.36805 20.6422 8.93923 19.0418M1.1457 11.0874C0.756206 9.68925 1.16125 8.17761 2.19765 7.1615M11.2352 5.21497C11.5394 4.66767 11.6396 4.00617 11.4647 3.35357C11.1074 2.01991 9.73653 1.22845 8.40287 1.58581C7.0692 1.94316 6.27775 3.314 6.6351 4.64767C6.80997 5.30027 7.2275 5.82304 7.7646 6.14491M19.4079 6.19412C19.0461 4.78851 17.9395 3.68191 16.5339 3.32014M16.5795 8.9194C16.2226 7.58727 15.2696 6.47331 13.9304 5.82257C12.5911 5.17184 10.9752 5.03764 9.43808 5.4495C7.90101 5.86136 6.56868 6.78554 5.7342 8.01873C4.89972 9.25192 4.63144 10.6931 4.98839 12.0252C5.57896 14.2293 5.46429 15.9877 5.09133 17.3238C4.66627 18.8467 4.45373 19.6081 4.51115 19.761C4.57684 19.9359 4.62436 19.9839 4.79859 20.0514C4.95089 20.1104 5.59066 19.939 6.8702 19.5962L18.7353 16.4169C20.0148 16.0741 20.6546 15.9026 20.757 15.7754C20.8741 15.6298 20.8912 15.5645 20.8607 15.3801C20.834 15.219 20.2692 14.6659 19.1396 13.5596C18.1486 12.5889 17.1701 11.1235 16.5795 8.9194Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.13a0436d.svg";
export { ForwardRef as ReactComponent };